import React from "react";
import { Box } from "@mui/material";
import { brand } from "../theme";

// Isotipo de Caro: una "C" con forma de velocímetro y la aguja a fondo
const Logo = ({ size = 40, sx }) => (
  <Box
    component="svg"
    viewBox="0 0 64 64"
    role="img"
    aria-label="Caro"
    sx={{ width: size, height: size, flexShrink: 0, display: "block", ...sx }}
  >
    <rect width="64" height="64" rx="16" fill={brand.ink} />
    <path
      d="M44.73 19.27 A18 18 0 1 0 44.73 44.73"
      fill="none"
      stroke={brand.coral}
      strokeWidth="7"
      strokeLinecap="round"
    />
    <line
      x1="32"
      y1="32"
      x2="41.8"
      y2="25.1"
      stroke={brand.cream}
      strokeWidth="4"
      strokeLinecap="round"
    />
    <circle cx="32" cy="32" r="4.5" fill={brand.cream} />
  </Box>
);

export default Logo;
